module.exports = __webpack_public_path__ + "img/CH01-036-037.d3ae0a24.jpg";